import AllUsers from "./AllUsers";

export default AllUsers;
